<app-app-bar></app-app-bar>

<app-main-content>
  <div class="lens-page lens-spots">
    <section class="dash-container spots-header lens-banner">
      <div class="spots-header__intro">
        <h1 class="dash-section-head__title">Spots</h1>
        <p class="dash-section-head__subtitle">
          Best internet, study, and service spots across campus
        </p>
      </div>
      <div class="spots-view-toggle lens-toggle" role="tablist" aria-label="Spots view">
        <button
          type="button"
          class="spots-view-toggle__btn"
          [class.spots-view-toggle__btn--active]="activeView() === 'spots'"
          role="tab"
          [attr.aria-selected]="activeView() === 'spots'"
          (click)="setView('spots')"
        >
          Spots
        </button>
        <button
          type="button"
          class="spots-view-toggle__btn"
          [class.spots-view-toggle__btn--active]="activeView() === 'analysis'"
          role="tab"
          [attr.aria-selected]="activeView() === 'analysis'"
          (click)="setView('analysis')"
        >
          Spot Analysis
        </button>
      </div>
    </section>

    @if (activeView() === 'spots') {
    <div class="spots-layout">
    <section class="dash-container spots-filter-section" aria-labelledby="spot-filter-title">
      <div class="spots-filter-panel">
        <header class="spots-filter-panel__header">
          <span class="spots-filter-panel__icon"><mat-icon>tune</mat-icon></span>
          <div>
            <h2 id="spot-filter-title">Find the right spot</h2>
            <p>Choose what you need and when you plan to visit.</p>
          </div>
        </header>

        <div class="spots-filter-group">
          <p class="spots-filter-group__label"><mat-icon>place</mat-icon>Service</p>
          <div class="dash-chips" role="group" aria-label="Service">
            @for (cat of spotCategories; track cat.id) {
            <button type="button" class="dash-chip"
              [class.dash-chip--active]="activeCategory() === cat.id"
              [attr.aria-pressed]="activeCategory() === cat.id"
              (click)="setCategory(cat.id)">{{ cat.label }}</button>
            }
          </div>
        </div>

        @if (activeCategory() === 'internet') {
        <div class="spots-filter-group">
          <p class="spots-filter-group__label"><mat-icon>wifi</mat-icon>Best for</p>
          <div class="dash-chips" role="group" aria-label="Internet activity">
            @for (act of activityFilters; track act.id) {
            <button type="button" class="dash-chip"
              [class.dash-chip--active]="activeActivity() === act.id"
              [attr.aria-pressed]="activeActivity() === act.id"
              (click)="setActivity(act.id)">{{ act.label }}</button>
            }
          </div>
        </div>
        }

        <div class="spots-filter-group">
          <p class="spots-filter-group__label"><mat-icon>schedule</mat-icon>When</p>
          <div class="dash-chips" role="group" aria-label="Time of day">
            @for (t of timeFilters; track t.id) {
            <button type="button" class="dash-chip"
              [class.dash-chip--active]="activeTime() === t.id"
              [attr.aria-pressed]="activeTime() === t.id"
              (click)="setTime(t.id)">{{ t.label }}</button>
            }
          </div>
        </div>
      </div>
    </section>

    @if (activeCategory() === 'internet') {
    <section
      class="dash-container spots-ranked"
      aria-label="Best internet spots"
    >
      @if (recommendationsLoading()) {
      <div class="spots-empty" aria-live="polite"><p>Loading spots…</p></div>
      } @else if (recommendationsError()) {
      <div class="spots-empty" role="alert">
        <mat-icon>wifi_off</mat-icon><p>Spots are temporarily unavailable.</p>
      </div>
      } @else if (filteredInternetSpots().length) {
      <div class="spots-ranked__list">
        @for (spot of filteredInternetSpots(); track spot.id) {
        <button
          type="button"
          class="spots-rank-card"
          [class.spots-rank-card--top]="spot.rank === 1"
          (click)="openSpot(spot.id)"
        >
          <span
            class="spots-rank-card__rank"
            [class.spots-rank-card__rank--top]="spot.rank === 1"
            >{{ spot.rank }}</span
          >
          <span class="spots-rank-card__body">
            <span class="spots-rank-card__name">{{ spot.name }}</span>
            <span class="spots-rank-card__meta">{{ spot.meta }}</span>
          </span>
          <span class="spots-rank-card__side">
            <span
              class="dash-spot__badge"
              [class]="'dash-spot__badge--' + qualityClass(spot.quality)"
              >{{ spot.quality }}</span
            >
            <span
              class="spots-confidence spots-confidence--{{
                spot.confidence.toLowerCase()
              }}"
            >
              <span class="spots-confidence__dot"></span>{{ spot.confidence }}
            </span>
          </span>
        </button>
        }
      </div>
      } @else {
      <div class="spots-empty">
        <mat-icon>wifi_off</mat-icon>
        <p>
          No ranked spots yet for this activity and time. Try a different
          filter.
        </p>
      </div>
      }
    </section>
    } @if (activeCategory() === 'study') {
    <section
      class="dash-container spots-availability-section"
      aria-label="Study spots"
    >
      <h2 class="dash-section-head__title spots-availability-section__title">
        Study Areas
      </h2>
      @if (recommendationsLoading()) {
      <div class="spots-empty" aria-live="polite"><p>Loading spots…</p></div>
      } @else if (recommendationsError()) {
      <div class="spots-empty" role="alert"><p>Spots are temporarily unavailable.</p></div>
      } @else if (!availabilitySpots().length) {
      <div class="spots-empty"><p>No study recommendations are available yet.</p></div>
      } @else {
      <div class="spots-availability-list">
        @for (spot of availabilitySpots(); track spot.id) {
        <button
          type="button"
          class="spots-availability-item"
          (click)="openSpot(spot.id)"
        >
          <span class="spots-availability-item__icon"
            ><mat-icon>{{ spot.icon }}</mat-icon></span
          >
          <span class="spots-availability-item__body">
            <span class="spots-availability-item__name">{{ spot.name }}</span>
            <span class="spots-availability-item__meta">{{ spot.meta }}</span>
          </span>
          <span
            class="spots-availability-badge spots-availability-badge--{{
              spot.availability.toLowerCase().replace(' ', '-')
            }}"
            >{{ spot.availability }}</span
          >
        </button>
        }
      </div>
      }
    </section>
    } @if (activeCategory() === 'cafe') {
    <section
      class="dash-container spots-availability-section"
      aria-label="Cafes"
    >
      <h2 class="dash-section-head__title spots-availability-section__title">
        Cafes
      </h2>
      @if (recommendationsLoading()) {
      <div class="spots-empty" aria-live="polite"><p>Loading spots…</p></div>
      } @else if (recommendationsError()) {
      <div class="spots-empty" role="alert"><p>Spots are temporarily unavailable.</p></div>
      } @else if (!availabilitySpots().length) {
      <div class="spots-empty"><p>No cafe recommendations are available yet.</p></div>
      } @else {
      <div class="spots-availability-list">
        @for (spot of availabilitySpots(); track spot.id) {
        <button
          type="button"
          class="spots-availability-item"
          (click)="openSpot(spot.id)"
        >
          <span class="spots-availability-item__icon"
            ><mat-icon>{{ spot.icon }}</mat-icon></span
          >
          <span class="spots-availability-item__body">
            <span class="spots-availability-item__name">{{ spot.name }}</span>
            <span class="spots-availability-item__meta">{{ spot.meta }}</span>
          </span>
          <span
            class="spots-availability-badge spots-availability-badge--{{
              spot.availability.toLowerCase().replace(' ', '-')
            }}"
            >{{ spot.availability }}</span
          >
        </button>
        }
      </div>
      }
    </section>
    } @if (activeCategory() === 'other' || activeCategory() === 'classroom' || activeCategory() === 'lab') {
    <section
      class="dash-container spots-availability-section"
      [attr.aria-label]="activeCategory() === 'classroom' ? 'Classrooms' : activeCategory() === 'lab' ? 'Labs' : 'Other spots'"
    >
      <h2 class="dash-section-head__title spots-availability-section__title">
        {{ activeCategory() === 'classroom' ? 'Classrooms' : activeCategory() === 'lab' ? 'Labs' : 'Other spots' }}
      </h2>
      @if (recommendationsLoading()) {
      <div class="spots-empty" aria-live="polite"><p>Loading spots…</p></div>
      } @else if (recommendationsError()) {
      <div class="spots-empty" role="alert"><p>Spots are temporarily unavailable.</p></div>
      } @else if (!availabilitySpots().length) {
      <div class="spots-empty"><p>No other recommendations are available yet.</p></div>
      } @else {
      <div class="spots-availability-list">
        @for (spot of availabilitySpots(); track spot.id) {
        <button
          type="button"
          class="spots-availability-item"
          (click)="openSpot(spot.id)"
        >
          <span class="spots-availability-item__icon"
            ><mat-icon>{{ spot.icon }}</mat-icon></span
          >
          <span class="spots-availability-item__body">
            <span class="spots-availability-item__name">{{ spot.name }}</span>
            <span class="spots-availability-item__meta">{{ spot.meta }}</span>
          </span>
          <span
            class="spots-availability-badge spots-availability-badge--{{
              spot.availability.toLowerCase().replace(' ', '-')
            }}"
            >{{ spot.availability }}</span
          >
        </button>
        }
      </div>
      }
    </section>
    }
    </div>
    } @else {
    <section class="dash-container spots-search">
      <div class="spots-search-bar">
        <mat-icon>search</mat-icon>
        <input
          type="text"
          placeholder="Search a building, floor, or spot…"
          [value]="searchQuery()"
          (input)="onSearch($event)"
        />
      </div>
    </section>

    <section
      class="dash-container spots-directory"
      aria-label="All monitored locations"
    >
      <header class="dash-section-head dash-section-head--compact">
        <div>
          <h2 class="dash-section-head__title">All Monitored Locations</h2>
        </div>
        <span class="spots-directory__count"
          >{{ directoryTotal() }} spots</span
        >
      </header>

      @if (directoryLoading()) {
      <div class="spots-empty" aria-live="polite"><p>Loading monitored locations…</p></div>
      } @else if (directoryError()) {
      <div class="spots-empty" role="alert">
        <mat-icon>location_off</mat-icon><p>Monitored locations are temporarily unavailable.</p>
      </div>
      } @else if (filteredDirectory().length) {
      <div class="spots-directory__list">
        @for (spot of filteredDirectory(); track spot.id) {
        <button
          type="button"
          class="spots-directory-item"
          (click)="openSpot(spot.id)"
        >
          <span class="spots-directory-item__icon"
            ><mat-icon>{{ spot.icon }}</mat-icon></span
          >
          <span class="spots-directory-item__body">
            <span class="spots-directory-item__name">{{ spot.name }}</span>
            <span class="spots-directory-item__meta">{{ spot.building }}</span>
          </span>
          <span class="spots-directory-item__updated">{{
            spot.updatedAgo
          }}</span>
          <mat-icon class="spots-directory-item__chevron"
            >chevron_right</mat-icon
          >
        </button>
        }
      </div>
      } @else {
      <div class="spots-empty">
        <mat-icon>search_off</mat-icon>
        @if (searchQuery().trim()) {
        <p>No spots match "{{ searchQuery() }}".</p>
        } @else {
        <p>No spots have internet test data for any time slot yet.</p>
        }
      </div>
      }
    </section>
    }
  </div>
</app-main-content>
